import React, {useEffect, useState} from 'react';
import './ballsPage.scss';
import {BallsModel} from "./models/BallsModel";
import {getRequest} from "../requests/HelperRequest";
import {Loading} from "../shared/Loading";
import {formatDateTime} from "../helper/Formatting";
import {Group, Card, Button, Text, Title} from '@mantine/core';
import {BallsStore} from "./BallsStore";

const packages = [
    {name: 'Малый пакет', price: 390, points: 195, pricePerPoint: 2},
    {name: 'Небольшой пакет', price: 800, points: 400, pricePerPoint: 2},
    {name: 'Средний пакет', price: 1575, points: 787, pricePerPoint: 2},
    {name: 'Выше среднего пакет', price: 2200, points: 1100, pricePerPoint: 2},
    {name: 'Большой пакет', price: 2975, points: 1487, pricePerPoint: 1},
];

export const BallsPage = () => {
    let [balls, setBalls] = useState<BallsModel[] | undefined>(undefined);
    let store = new BallsStore();
    const request = () => {
        setBalls(undefined);
        getRequest<BallsModel[]>("api/Balls")
            .then(x => {
                if (!!x.Model) {
                    setBalls(x.Model!)
                } else if (!!x.ErrorM) {
                    alert(x.Error)
                }
            });
    }

    useEffect(() => {
        request();
    }, [])

    const buyBalls = (points: number, price: number) => {
        store.request({amount: price});
    }

    return (
        <div className="balls-page">
            <div className="purchase">
                <Title order={2} className="purchase-title">Купить баллы</Title>
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <Group direction="column" spacing="sm" className="content_group">
                        {packages.map((pkg, index) => (
                            <div key={index} className="package-option">
                                <Text className="package-name">{pkg.name}</Text>
                                <Text>{pkg.price} рублей</Text>
                                <Text>{pkg.points} баллов ({pkg.pricePerPoint}р/балл)</Text>
                                <Button onClick={() => buyBalls(pkg.points, pkg.price)}
                                        className="balls_button">Купить</Button>
                            </div>
                        ))}
                    </Group>
                </Card>
            </div>
            <div className="history">
                <h1>История баллов</h1>
                {!balls && <Loading/>}
                {balls?.map((x, index) => (
                    <Card shadow="sm" padding="lg" radius="md" withBorder className="page" key={x.id}>
                        <div>
                            {x.balls > 0 && <div>Добавили баллов: {x.balls}</div>}
                            {x.balls <= 0 && <div>Потратили баллов: {-x.balls}</div>}
                        </div>
                        <div>Дата: {formatDateTime(x.dateWriteOff)}</div>
                    </Card>
                ))}
            </div>
        </div>
    );
};
